define("powergen/models/point",
  [],
  function() {
    "use strict";
    var Point;

    Point = DS.Model.extend({
      x: DS.attr('number', {
        defaultValue: 0
      }),
      y: DS.attr('number', {
        defaultValue: 0
      })
    });


    return Point;
  });